module.exports = __webpack_public_path__ + "static/media/im10.9120adf0.png";